export default __webpack_public_path__ + "static/media/gcp_bucket.0bd65644.png";